import React from "react";
import '../styles/home.css';
import cogIcon from "../assets/images/icons/cog.svg";
import envelopeIcon from "../assets/images/icons/envelope.svg";
import informationIcon from "../assets/images/icons/information.svg";
import walletIcon from "../assets/images/icons/wallet.svg";
import Translator from "../services/Translator";


export default function Home({lang, user, screen, setScreen, setText}: any) {
    const services = [
        {id: 'documents', name: 'navigation.documents', icon: walletIcon},
        {id: 'xmkbox', name: 'xmkBOX', icon: envelopeIcon},
        {id: 'information', name: 'navigation.information', icon: informationIcon},
        {id: 'settings', name: 'navigation.settings', icon: cogIcon},
    ];

    return (
        <div id="home" style={{display: user === undefined || user === null || screen !== 'home' ? 'none' : 'block'}}>
            <div className="container">
                <div className="row">
                    {
                        services.map((service, key) => {
                            return (
                                <div className={"col-4 icon"} key={key}>
                                    <div className="card">
                                        <div className="card-header" onClick={() => {setScreen(service.id); setText(Translator.trans(lang, service.name))}}>
                                            <img src={service.icon} alt="" />
                                            {Translator.trans(lang, service.name)}
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
}
